import React from "react";
import styled from "styled-components";
import { portalColors } from "./BusinessPortalComponents";

const CheckboxContainer = styled.label`
  position: relative;
  display: inline-block;
  vertical-align: middle;
  cursor: ${p => p.$disabled ? "not-allowed" : "pointer"};
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div`
  background-clip: content-box;
  background-color: ${props => (props.checked ? props.color || "#85b336" : portalColors.surface)};
  box-sizing: border-box;
  height: ${p => p.height || "20px"};
  padding: ${p => p.padding || "5px"};
  border-radius: ${ p => p.radius || "8px"};
  transition: all 150ms;
  width: ${p => p.width || "20px"};
  border: ${p => p.border || `1px solid ${portalColors.inputBorder}`};
  opacity: ${p => p.$disabled ? 0.75 : 1};

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 4px ${portalColors.blueSoft};
  }
`;

const Checkbox = ({
    checked,
    onClickCallback,
    disabled,
    onChange,
    readOnly,
    color,
    height,
    width,
    padding,
    radius,
    border,
    ...inputProps
}) => (
    <CheckboxContainer onClick={disabled ? undefined : onClickCallback} $disabled={disabled}>
        <HiddenCheckbox
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            readOnly={readOnly || !onChange}
            {...inputProps}
        />
        <StyledCheckbox
            checked={checked}
            $disabled={disabled}
            color={color}
            height={height}
            width={width}
            padding={padding}
            radius={radius}
            border={border}
        >
        </StyledCheckbox>
    </CheckboxContainer>
);

export default Checkbox;
